import { apiRequest } from './api';

// ── Types ────────────────────────────────────────────

export type ExpenseCategoryRecord = {
    id: string;
    organization_id: string;
    school_id: string;
    name: string;
    description: string | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;
};

export type CreateExpenseCategoryPayload = {
    school_id: string;
    name: string;
    description?: string | null;
    is_active?: boolean;
};

export type UpdateExpenseCategoryPayload = {
    name?: string;
    description?: string | null;
    is_active?: boolean;
};

// ── API Functions ────────────────────────────────────

export async function fetchExpenseCategories(): Promise<ExpenseCategoryRecord[]> {
    const res = await apiRequest<ExpenseCategoryRecord[]>('/api/expense-categories');
    return res.data;
}

export async function createExpenseCategory(
    payload: CreateExpenseCategoryPayload
): Promise<ExpenseCategoryRecord> {
    const res = await apiRequest<ExpenseCategoryRecord>('/api/expense-categories', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res.data;
}

export async function updateExpenseCategory(
    id: string,
    payload: UpdateExpenseCategoryPayload
): Promise<ExpenseCategoryRecord> {
    const res = await apiRequest<ExpenseCategoryRecord>(`/api/expense-categories/${id}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
    });
    return res.data;
}

export async function deleteExpenseCategory(id: string): Promise<void> {
    await apiRequest(`/api/expense-categories/${id}`, {
        method: 'DELETE',
    });
}
